import WarningIcon from '@mui/icons-material/Warning';
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import {
	ERROR_HEADER,
	NON_QUOTES_ERROR_LN1,
	NON_QUOTES_ERROR_LN2,
	NON_QUOTES_ERROR_LN3,
} from '../data/labelsAndMessages';

const useStyles = makeStyles((theme) => ({
	root: {
		height: 'auto',
	},
}));

export const NonQuoteApplicationError = () => {
	const classes = useStyles();
	return (
		<div style={{ backgroundColor: '#F0F0F0', height: '100%' }}>
			<Card className={classes.root}>
				<CardContent>
					<Grid container justifyContent='space-between'>
						<Grid item style={{ width: '100%' }}>
							<Stack direction='column' textAlign='center'>
								<Typography gutterBottom variant='h1'>
									<WarningIcon /> {ERROR_HEADER()}
								</Typography>
								<Typography gutterBottom variant='subtitle1'>
									{NON_QUOTES_ERROR_LN1()}
								</Typography>
								<Typography gutterBottom variant='subtitle1'>
									{NON_QUOTES_ERROR_LN2()}
								</Typography>
								<Typography gutterBottom variant='subtitle1'>
									{NON_QUOTES_ERROR_LN3()}
								</Typography>
							</Stack>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</div>
	);
};
